import { GET_ALL_COUNTRIES, POST_REGISTER_COMPANY } from '../constants';
import { defaultCreateAction } from 'utils/redux';
import { defaultTransform } from '../utils';

export const registerCompany = defaultCreateAction(POST_REGISTER_COMPANY, 'company/register/');

export const loadAllCountries = () => ({
  type: GET_ALL_COUNTRIES,
  meta: {
    method: 'GET',
    endpoint: 'countries/'
  },
  i18n: {
    trans: defaultTransform('countries', 'name')
  }
});



// WEBPACK FOOTER //
// ./src/actions/companies.js